export const REQUIRED_FIELDS = [
  { key: 'serialNumber', weight: 14.7 },
  { key: 'productNumber', weight: 10.2 },
  { key: 'serviceTagNumber', weight: 5.1 },
  { key: 'model', weight: 12.4 },
  { key: 'manualAvailable', weight: 12.6 },
  { key: 'scandate', weight: 12.7 },
  { key: 'operatingHours', weight: 12.3 },
  { key: 'warrantyStatus', weight: 10 },
  { key: 'assigned', weight: 10 },
];

export function computeDataQualityScore(device) {
  if (!device) return null;
  if (!REQUIRED_FIELDS.length) {
    console.warn('No required fields defined for data quality score');
    return null;
  }
  let score = 0;
  for (const field of REQUIRED_FIELDS) {
    const value = device[field.key];
    const missing =
      value === null ||
      value === undefined ||
      value === '' ||
      value === false ||
      (typeof value === 'string' && value.trim().toUpperCase() === 'N/A') ||
      (Array.isArray(value) && value.length === 0);
    if (!missing) {
      score += field.weight;
    }
  }
  const clamped = Math.min(100, Math.max(0, score));
  return parseFloat(clamped.toFixed(1));
}

export function computeAverageScore(scores) {
  if (!scores || scores.length === 0) return null;
  const sum = scores.reduce((a, b) => a + b, 0);
  const avg = sum / scores.length;
  const clamped = Math.min(100, Math.max(0, avg));
  return parseFloat(clamped.toFixed(1));
}
